import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

interface StyledActionPanelProps {
  $bottomAppBarBottom: number;
  $position: 'center' | 'right';
}

const StyledActionPanel = styled.div.attrs({
    className: "u-row-center"
})<StyledActionPanelProps>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: ${({ $bottomAppBarBottom }) => `${$bottomAppBarBottom + 80}px`};
  transition: bottom 0.2s;
  z-index: 4;
  padding: 4px 16px;
  justify-content: ${({ $position }) => {
    switch ($position) {
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }};
`;

interface RootState {
  layout: string;
}

interface ActionPanelProps {
  children: ReactNode;
  scrollEnabled?: boolean;
  position?: 'center' | 'right';
}

const ActionPanel: React.FC<ActionPanelProps> = ({ 
  children, 
  scrollEnabled = true, 
  position = 'center' 
}) => {
  const scrollState = useSelector((state: RootState) => state.layout);
  
  const bottomAppBarBottom = !scrollEnabled
    ? 0
    : scrollState === "down"
      ? -80
      : 0;

  return (
    <StyledActionPanel 
      $bottomAppBarBottom={bottomAppBarBottom}
      $position={position}
    >
      {children}
    </StyledActionPanel>
  );
};

export default ActionPanel;
